import { render } from "./mail_history.vue?vue&type=template&id=ce7fdf3c"
import script from "./mail_history.vue?vue&type=script&lang=js"
export * from "./mail_history.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__